import {
  get as getAxios,
  put as putAxios,
  post as postAxios,
} from "../apiHandler";

const endPoint = process.env.REACT_APP_API_BASE_URL;
const PAGE_SIZE = 5;

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, endPoint, params });
const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });

export default class Family {
  static getFamilyDetailsByMemberId(memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/families/${memberId}`, {
      accessToken: accessTokenFromLocal,
    });

    Family.getFamilyDetailsByMemberId.cancel = request.cancel;
    return request;
  }

  static createFamily(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/families/newFamily`, {
      data,
      accessToken: accessTokenFromLocal,
    });
    Family.createFamily.cancel = request.cancel;
    return request;
  }

  static searchFamilyDetails({ query, params }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/families/search`, {
      data: query,
      params: {
        size: params?.pageSize ?? PAGE_SIZE,
        page: params?.page ?? 0,
      },
      accessToken: accessTokenFromLocal,
    });
    Family.searchFamilyDetails.cancel = request.cancel;
    return request;
  }

  static updateFamily(data, id) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/families/${id}`, {
      data,
      accessToken: accessTokenFromLocal,
    });
    Family.updateFamily.cancel = request.cancel;
    return request;
  }

  static getRelationshipByFamilyId(familyId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/families/${familyId}/relationships`, {
      accessToken: accessTokenFromLocal,
    });
    Family.updateFamily.cancel = request.cancel;
    return request;
  }
}
